import React from 'react';
// Import Shared Components
import { Card } from 'shared-components';
// Import Local Components
import DownloadFile from './DownloadFile';
import ValueUnloadDetails from './ValueUnloadDetails';
// // Import Component Styles
import { ActionsContainer } from './styles';

export default function({ loadStep, ...props }) {
  return <Card>
    <ActionsContainer>
      {loadStep === 1 && <DownloadFile />}
      {loadStep === 2 && <ValueUnloadDetails {...props} />}
    </ActionsContainer>
  </Card>;
};
